import { render } from "./app-header-sticky.vue?vue&type=template&id=00462cac&scoped=true"
import script from "./app-header-sticky.vue?vue&type=script&lang=js"
export * from "./app-header-sticky.vue?vue&type=script&lang=js"

import "./app-header-sticky.vue?vue&type=style&index=0&id=00462cac&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00462cac"]])

export default __exports__